/*!
Copyright (C) 2022 Liberty Infrasystems. All rights reserved.
*/

/* eslint-disable no-console, no-await-in-loop */

import { retryIfNull } from '@libertyio/retry-util-js';

async function requestWithRetry(fn, options = {}) {
    const { maxAttempts = 7, randomizeBackoff = true, backoffOptions = {} } = options;
    backoffOptions.alg ??= 'exponential';
    const conditionalRetry = async () => {
        try {
            const response = await fn();
            // console.log(`requestWithRetry: response ${JSON.stringify(response)}`);
            return response;
        } catch (err) {
            console.error('requestWithRetry caught error', err);
            if (Number.isInteger(err.response?.status)) {
                if (err.response.status >= 300 && err.response.status < 400) {
                    // we don't retry requests that resulted in a redirect
                    throw err;
                }
                if (err.response.status >= 400 && err.response.status < 500) {
                    // we don't retry requests that failed due to client error
                    throw err;
                }
            }
            return null; // retry the request
        }
    };
    const response = await retryIfNull(conditionalRetry, {
        maxAttempts,
        backoffOptions,
        randomizeBackoff,
    });
    return response;
}

export { requestWithRetry };
